import { Button } from '@/components/ui/button'
import { Bell, User, ChevronDown, Database, ArrowLeft } from 'lucide-react'
import { getUserBranch } from '@/utils/user-role'

interface HeaderProps {
  currentMenu: string
  onNavigate: (menu: string) => void
  currentUser?: string
}

function getWelcomeName(username: string): string {
  const branch = getUserBranch(username)
  if (branch) return `${branch}行长`
  return username
}

export function Header({ currentMenu, onNavigate, currentUser = 'eagle' }: HeaderProps) {
  const welcomeName = getWelcomeName(currentUser)

  return (
    <header className="h-14 border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 flex items-center justify-between px-6 sticky top-0 z-50 shadow-header">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-gradient-to-br from-gcb-primary to-gcb-primaryLight rounded-lg flex items-center justify-center shadow-md">
            <Database className="w-4 h-4 text-white" />
          </div>
          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gcb-primaryDark leading-tight">广州银行</span>
            <span className="text-[10px] text-gray-500 -mt-0.5">智数坊</span>
          </div>
        </div>

        {/* 导航已隐藏 */}

        {/* 欢迎语 */}
        <div className="ml-4 pl-4 border-l border-gray-200">
          <p className="text-sm text-gray-600">
            <span className="font-medium text-gcb-primaryDark">{welcomeName}</span>，欢迎您。
            <span className="text-gray-400 ml-1">2026年6月10日数据已更新。</span>
          </p>
        </div>
      </div>

      {/* 右侧操作区 */}
      <div className="flex items-center gap-2">
        {currentMenu === 'report' && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onNavigate('home')}
            className="gap-2 text-gray-600 hover:text-gcb-primary transition-colors h-8 text-xs"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            返回
          </Button>
        )}

        {currentMenu === 'myspace' && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onNavigate('home')}
            className="gap-2 text-gray-600 hover:text-gcb-primary transition-colors h-8 text-xs"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            返回
          </Button>
        )}

        {currentMenu === 'catalog' && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onNavigate('home')}
            className="gap-2 text-gray-600 hover:text-gcb-primary transition-colors h-8 text-xs"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            返回
          </Button>
        )}

        {/* 通知 */}
        <Button
          variant="ghost"
          size="icon"
          className="relative text-gray-600 hover:text-gcb-primary hover:bg-blue-50 transition-all h-8 w-8"
        >
          <Bell className="w-4 h-4" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
        </Button>

        {/* 分享已隐藏 */}
        {/* <Button
          variant="ghost"
          size="icon"
          className="text-gray-600 hover:text-gcb-primary hover:bg-blue-50 transition-all h-8 w-8"
        >
          <Share2 className="w-4 h-4" />
        </Button> */}

        {/* 用户信息 */}
        <div className="flex items-center gap-2 pl-3 ml-1 border-l border-gray-200">
          <div className="w-7 h-7 rounded-full bg-gradient-to-br from-gcb-primary to-gcb-primaryLight flex items-center justify-center shadow-md">
            <User className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="text-xs font-medium text-gray-700">{currentUser}</span>
          <ChevronDown className="w-3.5 h-3.5 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors" />
        </div>
      </div>
    </header>
  )
}
